import React from 'react'
import { Link } from 'react-router-dom'
import { Space, Tag, Typography } from 'antd'

import { FETCHER_LABELS, MAX_TASK_RETRIES } from '../../app-constants'

export const columns = (
  setCurrentTask,
  setShowUpdateModal,
  setShowDeleteModal
) => [
  {
    title: 'Task Type',
    dataIndex: 'type',
    key: 'type',
    width: 100,
    render: (text, record) => (
      <Space size="middle" style={{ fontWeight: 'bold' }}>
        {/* eslint-disable-next-line */}
        {record.type ? `${record.type.split('_').join(' ')}` : 'N/A'}
      </Space>
    )
  },
  {
    title: 'Car URL',
    dataIndex: 'carUrl',
    key: 'carUrl',
    width: 150
  },
  {
    title: 'Stage',
    dataIndex: 'stage',
    key: 'stage',
    width: 100,
    render: (text, record) => (
      <Space size="middle" style={{ fontWeight: 'bold', textWrap: 'wrap' }}>
        {record.stage ? `${record.stage.split('_').join(' ')}` : 'N/A'}
      </Space>
    )
  },
  {
    // Where the task came from. A scrape the owner started in Telegram has somebody waiting on it;
    // one created here does not, which is the first thing you want to know before taking it over
    // (spec: bot-scrape-tasks Req 3.3).
    title: 'From',
    dataIndex: 'source',
    key: 'source',
    width: 90,
    // eslint-disable-next-line react/display-name
    render: (text, record) => (
      <Tag color={record.source === 'telegram' ? 'blue' : undefined}>
        {record.source === 'telegram' ? 'Telegram' : 'Dashboard'}
      </Tag>
    )
  },
  {
    // How many tries the scheduled sweep has left before it gives up on this one.
    title: 'Tries',
    dataIndex: 'retries',
    key: 'retries',
    width: 70,
    render: (text, record) => `${record.retries || 0} / ${MAX_TASK_RETRIES}`
  },
  {
    // WHY a task failed, in words ("the price is missing on the page"). Until the API stored this, a
    // failed task was only a stage and nothing said what to do about it.
    title: 'Why it failed',
    dataIndex: 'error',
    key: 'error',
    width: 220,
    // eslint-disable-next-line react/display-name
    render: (text, record) => {
      // Which rung fetched the page, beside the reason: "blocked" from our browser and "blocked"
      // from Zyte are different problems (spec: phone-first-scraping Req 3.1).
      const fetcher = record.fetcher ? (
        <Tag style={{ marginLeft: 6 }}>
          {FETCHER_LABELS[record.fetcher] || record.fetcher}
        </Tag>
      ) : null
      if (!record.error) return fetcher || '—'
      return (
        <Typography.Text type="danger" style={{ textWrap: 'wrap' }}>
          {record.error}
          {fetcher}
        </Typography.Text>
      )
    }
  },
  {
    // The car this task produced, or the one that was already there for a duplicate.
    title: 'Car',
    dataIndex: 'car',
    key: 'car',
    width: 90,
    // eslint-disable-next-line react/display-name
    render: (text, record) =>
      record.car ? <Link to={`/cars/${record.car}`}>Open</Link> : '—'
  },
  {
    title: 'Completed',
    dataIndex: 'completed',
    key: 'completed',
    width: 80,
    // eslint-disable-next-line react/display-name
    render: (text, record) => (
      <Space size="middle" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {/* eslint-disable-next-line */}
        {record.completed ? 'Yes' : 'No'}
      </Space>
    )
  },
  {
    title: 'Retries',
    dataIndex: 'retries',
    key: 'retries',
    width: 80,
    render: (text, record) => (
      <Space size="middle" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {/* eslint-disable-next-line */}
        {record.retries}
      </Space>
    )
  },
  {
    title: 'Completed At',
    dataIndex: 'completedAt',
    key: 'completedAt',
    width: 120,
    // eslint-disable-next-line react/display-name
    render: (text, record) => (
      <Space size="middle">
        {/* eslint-disable-next-line */}
        {record.completedAt
          ? `${new Date(record.completedAt).toDateString()} - ${new Date(
              record.completedAt
            ).toLocaleTimeString()}`
          : 'N/A'}
      </Space>
    )
  },
  {
    title: 'Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 150,
    // eslint-disable-next-line react/display-name
    render: (text, record) => (
      <Space size="middle">
        {/* eslint-disable-next-line */}
        <div>
          {record.updatedAt
            ? `${new Date(record.updatedAt).toDateString()} - ${new Date(
                record.updatedAt
              ).toLocaleTimeString()}`
            : 'Not Updated'}
          <br />
          <small style={{ color: 'gray' }}>
            {`Created: ${new Date(
              record.createdAt
            ).toDateString()} - ${new Date(
              record.createdAt
            ).toLocaleTimeString()}`}
          </small>
        </div>
      </Space>
    )
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    width: 120,
    // eslint-disable-next-line react/display-name
    render: (text, record) => (
      <Space size="middle">
        {/* eslint-disable-next-line */}
        <a
          onClick={() => {
            setCurrentTask(record)
            setShowUpdateModal(true)
          }}
        >
          Edit
        </a>
        {/* eslint-disable-next-line */}
        <a
          onClick={() => {
            setCurrentTask(record)
            setShowDeleteModal(true)
          }}
          className="text-danger"
        >
          Delete
        </a>
      </Space>
    )
  }
]
